import React, { useState, useEffect } from 'react';
import Layout from '../Layout/Layout.js';
import { APIUrl } from '../../Helper/APIUrl.js';
import { useSnackbar } from "notistack";
import { Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';

function ContactUs2() {

    const Token = JSON.parse(localStorage.getItem('tcn'));
    const { enqueueSnackbar } = useSnackbar();

    const [search, setsearch] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [contactList, setContactList] = useState([]);
    const [filterContactList, setFilterContactList] = useState([]);

    //For Show Details
    const [selectedDetails, setSelectedDetails] = useState(null);

    //API : Base Url + Controller Name
    const ConcateURL = APIUrl.ContactUs;

    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    const getAllContactUs = async () => {
        if (!Token) {
            console.error("Token not found");
            enqueueSnackbar("Authentication token not found", { variant: "error" });
            return;
        }

        try {
            console.log("Fetching from URL:", ConcateURL + 'GetAllContactUs');
            const response = await fetch(ConcateURL + 'GetAllContactUs', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify({})
            });

            console.log("Response status:", response.status);
            const result = await parseJSON(response);
            console.log("API Result:", result);

            if (result && result.Message === "Success" && result.data) {
                setContactList(result.data);
                setFilterContactList(result.data);
                // console.log('GetAllContactUs - Data loaded:', result.data);
                // enqueueSnackbar("Contacts loaded successfully", { variant: "success" });
            } else {
                console.warn('No data received from API', result);
                setContactList([]);
                setFilterContactList([]);
                enqueueSnackbar("No contacts found", { variant: "info" });
            }
        } catch (error) {
            console.error("Error fetching contact list:", error);
            setContactList([]);
            setFilterContactList([]);
            enqueueSnackbar("Error loading contact list: " + error.message, { variant: "error" });
        }
    };

    useEffect(() => {
        getAllContactUs();
    }, [])

    // Helper functions for date calculations
    const getTodayContacts = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return contactList.filter(x => {
            if (!x.CreatedOn) return false;
            const createdDate = new Date(x.CreatedOn);
            createdDate.setHours(0, 0, 0, 0);
            return createdDate.getTime() === today.getTime();
        }).length;
    };

    const getYesterdayContacts = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        yesterday.setHours(0, 0, 0, 0);
        return contactList.filter(x => {
            if (!x.CreatedOn) return false;
            const createdDate = new Date(x.CreatedOn);
            createdDate.setHours(0, 0, 0, 0);
            return createdDate.getTime() === yesterday.getTime();
        }).length;
    };

    const showDetails = (row) => {
        setSelectedDetails(row);
    };

    const closeDetails = () => {
        setSelectedDetails(null);
    };

    const coloumn = [
        {
            name: <strong>SNo.</strong>,
            selector: (row, index) => index + 1,
            width: "60px"
        },
        {
            name: <strong>Full Name</strong>,
            selector: (row) => row.FullName || "N/A",
            sortable: true,
            reorder: true
        },
        {
            name: <strong>Email</strong>,
            selector: (row) => row.Email || "N/A",
            sortable: true
        },
        {
            name: <strong>Phone</strong>,
            selector: (row) => row.Phone || "N/A",
        },
        {
            name: <strong>Subject</strong>,
            selector: (row) => row.Subject || "N/A",
            sortable: true
        },
        // {
        //     name: <strong>Status</strong>,
        //     selector: (row) => row.IsActive ?
        //         <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Active</label> :
        //         <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">Inactive</label>,
        // },
        {
            name: <strong>Action</strong>,
            cell: row =>
                <div>
                    <Button
                        onClick={() => showDetails(row)}
                        className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2"
                        style={{ border: "none" }}
                    >
                        <i className="fa fa-eye" aria-hidden="true"></i> Details
                    </Button>
                </div>
        }
    ];

    useEffect(() => {
        if (contactList && contactList.length > 0) {
            let result = contactList.filter(x => {
                return (x.FullName && x.FullName.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
                    (x.Email && x.Email.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
                    (x.Phone && x.Phone.toLowerCase().indexOf(search.toLowerCase()) !== -1);
            });

            // Apply date filter if selected
            if (selectedDate) {
                result = result.filter(x => {
                    if (!x.CreatedOn) return false;
                    const createdDate = new Date(x.CreatedOn).toISOString().split('T')[0];
                    return createdDate === selectedDate;
                });
            }

            setFilterContactList(result);
        } else {
            setFilterContactList([]);
        }
    }, [search, selectedDate, contactList]);

    return <div>
        <Layout>
            <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                <div className="space-y-6">
                    {/* Stats Cards */}
                    <div>
                        <h2 className="text-xl font-semibold text-gray-900 mb-6">Contact Overview</h2>
                    </div>
                    <div className="grid grid-cols-1 gap-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {/* Total Contacts Card */}
                            <div
                                onClick={() => { setsearch(""); setSelectedDate(""); }}
                                className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-6 border border-blue-200 cursor-pointer hover:shadow-lg transition-shadow"
                            >
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-sm font-medium text-blue-800">Total Contact Us</p>
                                        <p className="text-3xl font-bold text-blue-600 mt-2">
                                            {contactList.length}
                                        </p>
                                    </div>
                                    <div className="text-4xl text-blue-400">📧</div>
                                </div>
                            </div>

                            {/* Today Contacts Card */}
                            <div
                                onClick={() => { setsearch(""); setSelectedDate(new Date().toISOString().split('T')[0]); }}
                                className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-6 border border-green-200 cursor-pointer hover:shadow-lg transition-shadow"
                            >
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-sm font-medium text-green-800">Today Contact Us</p>
                                        <p className="text-3xl font-bold text-green-600 mt-2">
                                            {getTodayContacts()}
                                        </p>
                                    </div>
                                    <div className="text-4xl text-green-400">📅</div>
                                </div>
                            </div>

                            {/* Yesterday Contacts Card */}
                            <div
                                onClick={() => {
                                    setsearch("");
                                    const yesterday = new Date();
                                    yesterday.setDate(yesterday.getDate() - 1);
                                    setSelectedDate(yesterday.toISOString().split('T')[0]);
                                }}
                                className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg p-6 border border-orange-200 cursor-pointer hover:shadow-lg transition-shadow"
                            >
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-sm font-medium text-orange-800">Yesterday Contact Us</p>
                                        <p className="text-3xl font-bold text-orange-600 mt-2">
                                            {getYesterdayContacts()}
                                        </p>
                                    </div>
                                    <div className="text-4xl text-orange-400">📆</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Details Section */}
                    {selectedDetails && (
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-xl font-semibold text-gray-900">
                                    Contact Details
                                </h2>
                                <Button
                                    onClick={() => closeDetails()}
                                    style={{ background: "transparent", border: "none", padding: "0" }}
                                >
                                    <i className="fa fa-times fa-2x text-gray-600" aria-hidden="true"></i>
                                </Button>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Full Name
                                    </label>
                                    <p className="text-gray-900 bg-gray-50 px-4 py-3 rounded-lg border border-gray-200">{selectedDetails.FullName || "N/A"}</p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Email
                                    </label>
                                    <p className="text-gray-900 bg-gray-50 px-4 py-3 rounded-lg border border-gray-200">{selectedDetails.Email || "N/A"}</p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Phone
                                    </label>
                                    <p className="text-gray-900 bg-gray-50 px-4 py-3 rounded-lg border border-gray-200">{selectedDetails.Phone || "N/A"}</p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Subject
                                    </label>
                                    <p className="text-gray-900 bg-gray-50 px-4 py-3 rounded-lg border border-gray-200">{selectedDetails.Subject || "N/A"}</p>
                                </div>

                                <div className="md:col-span-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Message
                                    </label>
                                    <p className="text-gray-900 bg-gray-50 px-4 py-3 rounded-lg border border-gray-200 whitespace-pre-wrap">{selectedDetails.Message || "N/A"}</p>
                                </div>

                                {/* <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Status
                                    </label>
                                    <p className="text-gray-900 bg-gray-50 px-4 py-3 rounded-lg border border-gray-200">
                                        {selectedDetails.IsActive ?
                                            <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Active</span> :
                                            <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">Inactive</span>
                                        }
                                    </p>
                                </div> */}

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Created On
                                    </label>
                                    <p className="text-gray-900 bg-gray-50 px-4 py-3 rounded-lg border border-gray-200">
                                        {selectedDetails.CreatedOn ? new Date(selectedDetails.CreatedOn).toLocaleString() : 'N/A'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Contact List Table */}
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                        <div className="overflow-x-auto">
                            <DataTable
                                title="Manage Contact Us"
                                columns={coloumn}
                                data={filterContactList}
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[10, 25, 50]}
                                fixedHeader
                                fixedHeaderScrollHeight="550px"
                                selectableRows
                                selectableRowsHighlight
                                highlightOnHover
                                subHeader
                                subHeaderAlign="right"
                                subHeaderComponent={
                                    <div className="flex flex-col sm:flex-row gap-4 w-full">
                                        <input
                                            type="text"
                                            placeholder="Search by name, email, or phone"
                                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                            value={search}
                                            onChange={(e) => setsearch(e.target.value)}
                                        />
                                        <input
                                            type="date"
                                            value={selectedDate}
                                            onChange={(e) => setSelectedDate(e.target.value)}
                                            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        />
                                        {(search || selectedDate) && (
                                            <Button
                                                onClick={() => { setsearch(""); setSelectedDate(""); }}
                                                className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
                                                style={{ border: "none", whiteSpace: "nowrap" }}
                                            >
                                                Clear
                                            </Button>
                                        )}
                                    </div>
                                }
                            />
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    </div>;
}

export default ContactUs2;
